import React, { Component} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Edit from '@material-ui/icons/Edit';
import axios from 'axios';
import * as constants from '../config/constants';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AllocationHistory from './allocationHistory';
import AllocationCurrent from './allocationCurrent';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

function TabContainer(props) {
	return (
		<Typography component="div">
		{props.children}
		</Typography>
		);
}

TabContainer.propTypes = {
	children: PropTypes.node.isRequired,
};

const CustomTableCell = withStyles(theme => ({
	head: {
		backgroundColor: theme.palette.grey[200],
		color: theme.palette.common.black,
		textTransform: 'uppercase',
		fontWeight: 700
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);

const styles = theme => ({
	button: {
		margin: theme.spacing.unit,
		
	},
	table: {
		minWidth: 700,

	},
	root: {
		width: '100%',
		marginTop: theme.spacing.unit * 3,
		overflowX: 'auto',
	}
});

class Allocation extends Component {
	constructor() {
		super();
		this.state = {
			tabValue: 0,
			asset : [],
			open : false,
			user : [],
			assetId : '',
			userId : '',
			comments : ''
		}
		this.handleTabChange = this.handleTabChange.bind(this);
		this.handleAllocationDialog = this.handleAllocationDialog.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.addAllocate = this.addAllocate.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}
	componentDidMount() {
		let copiedStates = Object.assign({},this.state);
		let that = this;
		axios.get(constants.API_BASE_URL + "asset")
		.then(function(response){
			var asset = [];
			copiedStates.asset = response.data.details;
			console.log('Assets',copiedStates.asset);
			that.setState(copiedStates);
		})
		.catch(function(error){
			alert(error);
		})
		axios.get(constants.API_BASE_URL + "user")
		.then(function(response){
			var asset = [];
			copiedStates.user = response.data.details;
			that.setState(copiedStates);
		})
		.catch(function(error){
			alert(error);
		})
	}
	handleClose() {
		this.setState({
			open : false
		})
	}
	handleAllocationDialog() {
		this.setState({
			open : true
		})
	}
	addAllocate() {
		let that = this;
		let copiedStates = Object.assign({}, this.state);
		let request = {
			assetId : copiedStates.assetId,
			userId : copiedStates.userId,
			status : 'A',
			comments : copiedStates.comments
		}
		axios.post(constants.API_BASE_URL + "allocation",request)
		.then(function (response) {
			
		})
		.catch(function (error) {
		});
		this.setState({open : false});
	}
	handleInputChange(event) {
		let copiedStates = Object.assign({},this.state);
		copiedStates[event.target.name] = event.target.value;
		this.setState(copiedStates);
	}
	handleTabChange = (event, value) => {
		this.setState({
			tabValue: value
		});
	}
	render(){
		const { classes } = this.props;

		const {asset, user} = this.state;
		let assetComponent = [];
		let userComponent = [];

		asset.map(a => {
			assetComponent.push(
				<MenuItem value={a.id}>{a.id + " - " + a.name}</MenuItem>
				);
		});
		user.map(u => {
			userComponent.push(
				<MenuItem value={u.id}>{u.employeeId + " - " + u.name + " - " + u.email }</MenuItem>
				);
		});

		return(
			<div>

			<Button style={{
				position: 'fixed',
				bottom: '20px',
				right: '15px'
			}}
			variant="fab" color="primary" aria-label="add" className={classes.button} onClick={this.handleAllocationDialog}>
			<AddIcon />
			</Button>
			<Dialog
			
			fullWidth
			open={this.state.open}
			onClose={this.handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			>
			<DialogTitle id="alert-dialog-title">{"Add allocation"}</DialogTitle>
			<DialogContent>
			<DialogContentText id="alert-dialog-description">
			<FormControl fullWidth className = {classes.formControl}>
			<InputLabel htmlFor="age-simple">Asset Id - Name</InputLabel>
			<Select
			fullWidth
			value={this.state.assetId}
			onChange={this.handleInputChange}
			inputProps={{
				name: 'assetId',
				id: 'assetId'
			}}
			>
			{assetComponent}	
			</Select>
			</FormControl>
			<FormControl fullWidth className = {classes.formControl}>
			<InputLabel htmlFor="age-simple">Employee Id - Name</InputLabel>
			<Select
			fullWidth
			value={this.state.userId}
			onChange={this.handleInputChange}
			inputProps={{
				name: 'userId',
				id: 'userId'
			}}
			>
			{userComponent}	
			</Select>
			</FormControl>
			<TextField
			fullWidth
			id="comments"
			name="comments"
			multiLine
			placeholder="Comments"
			value={this.state.comments}
			onChange={this.handleInputChange}
			className={classes.textField}
			InputLabelProps={{
				shrink: true,
			}}
			margin="normal"
			/>
			
			</DialogContentText>
			</DialogContent>
			<DialogActions>
			<Button onClick={this.handleClose} color="primary" autoFocus>
			Cancel
			</Button>
			<Button variant="raised"onClick={this.addAllocate} color="primary">
			Allocate
			</Button>
			</DialogActions>
			</Dialog>
			
			<Paper className={classes.root}>
			<AppBar position="static" color="default">
			<Tabs 
			fullWidth
			centered
			value={this.state.tabValue} onChange={this.handleTabChange}>
			<Tab label="Current" />
			<Tab label="History" />
			</Tabs>
			</AppBar>

			{this.state.tabValue === 0 && <TabContainer><AllocationCurrent /></TabContainer>}
			{this.state.tabValue === 1 && <TabContainer><AllocationHistory /></TabContainer>}

			</Paper>

			</div>
			)
	}
}
Allocation.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Allocation);


// WEBPACK FOOTER //
// ./src/allocation/allocation.js